import * as  React from 'react';
import {Pagination, Col, Button, Card, Row} from 'antd';
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {RequestData} from '@models/axios';
import {FormattedMessage} from 'react-intl';


interface TableRendererProps {
  count: number;
  fetchRequest: (requestData: RequestData) => any;
  location: object;
}

const TableRenderer = <P extends object>(Component: React.ComponentType<P>) =>
  class TableRenderer extends React.Component<P & TableRendererProps> {
    
    state = {
      currentPage: 1
    };
    
    filter = {};
    paginationParams = PaginationDefaultParams;
    
    componentDidMount() {
      this.fetchData(this.props.defaultPageFilter);
    }
    
    fetchData = (params) => {
      if (params) {
        Object.assign(this.filter, params);
        
      }
      this.props.fetchRequest({
        params: {
          ...this.paginationParams,
          ...this.filter
        }
      });
    };
    
    search = (filter: object = {}) => {
      this.filter = filter;
      this.paginationParams = PaginationDefaultParams;
      this.fetchData(filter);
      this.setState({
        currentPage: 1
      })
    };
    
    getPageType = (): string => {
      //TODO Hugh:/
      return this.props.location.pathname.replace('/', '');
    };
    
    onChangePage = (page: number, pageSize: number = PaginationDefaultParams.count): void => {
      this.setState({
        currentPage: page
      });
      this.paginationParams = {
        offset: (page - 1) * pageSize,
        count: pageSize
      };
      this.fetchData();
    };
    
    render() {
      return (
        <div>
          <Component
            {...this.props as P}
            currentPage={this.state.currentPage}
            search={this.search}/>
          
          <Pagination
            size={`small`}
            current={this.state.currentPage}
            total={this.props.count}
            defaultPageSize={PaginationDefaultParams.count}
            showTotal={() => {
              return `تعداد کل: ${this.props.count}`; //TODO should be translate dynamically
            }}
            onChange={this.onChangePage}
          />
        </div>
      )
      
    }
  };

export default TableRenderer;